<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
<!--      <div class="container">-->
        <div class="row">
          <div class="col-md-12">
            <ol class="breadcrumb font-class">
              <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
              <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
              <li><a href="/#/bridge" v-on:click="sendMsg">桥梁振动监测</a></li>
              <li class="active">索力测试</li>
            </ol>
          </div>
        </div>
<!--      </div>-->
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
<!--      <div class="container">-->
        <div class="row">
          <div class="center_column col-xs-12 col-sm-12">
            <div class="rte">
              <h1 style="text-align:center;font-size: 20px">索力测试</h1>
              <hr>
              <p class="titleP">索力测试的重要性</p>
              <p style="">斜拉桥中的斜拉索，悬索桥中的主缆与吊索、系杆拱中的吊索和施工中的缆索等索力是极其重要的设计参数，
                设计和施工时通过调整拉索的索力，使塔、梁处于最佳受力状态。在运营过程中，
                亦应不断监测索力变化，及时调整索力，使之处于设计要求的状态。因此，
                无论施工过程还是运营过程中均需准确地测知索力。</p>
              <p class="titleP">索力测试的方法和步骤</p>
              <p>斜拉索在各种环境因素的作用下通常会激发起微小的振动，通过使用高分辨率高灵敏度的拾振传感器及其相应的数据采集设备和分析软件，由结构的振动分析出若干阶自振频率，最后由索力与其自振频率、边界条件、刚度等的关系式通过频率来反算索力。该方法具有测定简单、方便、快捷、测试设备可重复使用等突出优点，成为了现阶段工程界最受欢迎的索力测量方法之一。
                1.制定实验方案，包括测点的布设2.索力传感器安装3.使用数据采集仪进行数据采集4.数据分析5.计算索力值
              </p>
              <p class="titleP">广东某特大桥索力测试的仪器设备</p>
              <p>传感器：P12H型索力传感器</p>
              <p>传感器为无源传感器，无需供电，使用温度可达-40℃-80℃,体积小安装方便，
                性能稳定，防护等级IP67，信号传输距离可达3000米。</p>
              <p class="titleP">索力测试现场照片</p>
              <p>东某特大桥梁索力监测图</p>
              <div style="width:80%;margin: 0 auto 50px">
                <img src="../../../assets/center/bridge/cable/c1.png" alt="" style="width:100%;height:auto;">
              </div>
<!--              <div style="width:500px;">-->
<!--                <img src="../../../assets/center/bridge/cable/c2.png" alt="" style="width:100%;height:auto;">-->
<!--              </div>-->
<!--              <img src="../../../assets/center/bridge/cable/c1.png" alt="">-->
<!--              <img src="../../../assets/center/bridge/cable/c2.png" alt="">-->
            </div>
          </div>
        </div>
<!--      </div>-->
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    font-family: 宋体;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/bridge/bridge-cable.vue